<template>
  <div>
  <!-- Navigation -->
  <nav class="navbar navbar-expand-lg bg-primary text-uppercase fixed-top" id="mainNav">
    <div class="container">

        <img src="img/logo-min.png" alt="" style="width: 96px;">
      <button class="navbar-toggler navbar-toggler-right text-uppercase font-weight-bold bg-primary text-white rounded" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
        Menu
        <i class="fas fa-bars"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item mx-0 mx-lg-1">
            <a class="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger hoverr" @click="closeMenu()" href="/">HOME</a>
          </li>
          <li class="nav-item mx-0 mx-lg-1" v-if="mostrar">
            <a class="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger hoverr" @click="closeMenu(); mostrar=false; uno=false; dos=false;">Salir</a>
          </li>
         </ul>
      </div>
    </div>
  </nav>

  <section class="page-section portfolio masthead" id="portfolio" style="background-color: white !important; min-height: 600px;">
    <div class="container" style="padding-bottom: 25px;">
      <div v-if="!mostrar">
        <h2 class="text-uppercase text-left text-secondary mb-0 mt-3"> Ingreso de Alumnos </h2>

        <div class="text-left mt-2" >
          <span> Ingresa aqui tu DNI para consultar toda tu Información Academica.</span>

          <div class="row mt-3">
            <div class="col-sm-7 my-1">
              <div class="input-group">
                <input type="number" placeholder="Insert DNI" class="form-control" v-model="dni">
                <div class="input-group-btn input-group-append">
                  <div class="input-group-text" style="background-color: #234c8c; cursor: pointer; color: white;" @click="buscar();spinner=!spinner">
                    
                          <div v-if="!spinner"> <img src="/img/lupainv.png" alt="" style="width: 24px;"> </div>
                          <div v-else class="spinner-border spinner-border-sm" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                    </div>
                </div>
              </div>
            </div>
          </div> 
          <br>  
        </div>
        
      </div>
    <div v-if="mostrar">
      <h2 class="text-uppercase text-left text-secondary mb-0 mt-3"> Alumnos </h2> <br>
        <h3> {{alumno.nombre}} </h3>
     <div v-if="uno">
        <div class=" row justify-content-center">
          <div class="col-8 bg-secondary pt-3 pb-3" style="border-radius: 15px;">
            <!-- <div> Alumno :   {{alumno.nombre}} </div> -->
            <div> <h5>Curso:</h5>  <h5>{{alumno.curso.nombre}}</h5> </div>
            <div> <h6>Profesora: {{alumno.curso.docente.nombre}}</h6>  </div>
            <button @click="mostrar1=!mostrar1" class="btn btn-primary col-7 mb-2" type="button" data-toggle="collapse" :data-target="'#collapseExample'+1" aria-expanded="false" aria-controls="collapseExample">
              <div v-if="!mostrar1"> Ver
              </div>
              <div v-else> Ocultar
              </div>
              </button>
          </div>
        </div>

        <div class="collapse" :id="'collapseExample'+1">

          <br>

          <ul class="nav nav-pills mb-3 justify-content-center" id="pills-tab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Novedades</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Notas</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-contact" role="tab" aria-controls="pills-contact" aria-selected="false">Observaciones</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="pills-book-tab" data-toggle="pill" href="#pills-book" role="tab" aria-controls="pills-book" aria-selected="false">Libros</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="pills-otros-tab" data-toggle="pill" href="#pills-otros" role="tab" aria-controls="pills-otros" aria-selected="false">Reglamento</a>
            </li>
          </ul>
          <div class="tab-content mt-5 mb-5" id="pills-tabContent">
            <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab"> 
              <table class="table">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Date (Fecha)</th>
                    <th scope="col" colspan="3">Details (Detalles)</th>
                  </tr>
                </thead>
                <tbody v-for="(itemNovedad, index) in curso.novedades" :key=index>
                  <tr>
                    <td> {{itemNovedad.fecha}} </td>
                    <!-- <td colspan="3"> {{itemNovedad.novedad}} </td> -->
                    <td colspan="3" :id="'Nov'+curso.uid+index"> {{verSaltoLinea('Nov'+curso.uid+index,itemNovedad.novedad, false )}} </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
              <table class="table" v-if="alumno.notas">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Date (Fecha)</th>
                    <th scope="col">Oral (Oral)</th>
                    <th scope="col">Written (Escrito)</th>
                    <!-- <th scope="col">Commentary (Comentario)</th> -->
                  </tr>
                </thead>
                <tbody v-for="(itemNota, index) in alumno.notas.filter(n => n.uidCurso == alumno.curso.uid)" :key=index >
                  <tr>
                    <td> {{itemNota.fecha}} </td>
                    <td> {{itemNota.oral}} </td>
                    <td> {{itemNota.escrito}} </td>
                    <!-- <td> {{itemNota.comentario}} </td> -->
                  </tr>
                  <tr v-if="itemNota.comentario != ''">
                    <!-- <td colspan="3" class="text-left" style="border-top-width: 0px; border-bottom: 0.125rem solid #dee2e6;"> <b>Comentario:</b>  {{itemNota.comentario}} </td> -->
                    <td colspan="3" :id="'Notas'+alumno.dni+index" class="text-left" style="border-top-width: 0px; border-bottom: 0.125rem solid #dee2e6;"  > {{verSaltoLinea('Notas'+alumno.dni+index, itemNota.comentario, true )}} </td>
                  </tr>
                </tbody>
              </table>
              <table class="table" v-else>
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Date (Fecha)</th>
                    <th scope="col">Oral (Oral)</th>
                    <th scope="col">Written (Escrito)</th>
                    <!-- <th scope="col">Commentary (Comentario)</th> -->
                  </tr>
                </thead>
              </table>
            </div>
            <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
              <table class="table" v-if="alumno.observaciones">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Date (Fecha)</th>
                    <th scope="col" colspan="3">Details (Detalles)</th>
                  </tr>
                </thead>
                <tbody v-for="(itemObservaciones, index) in alumno.observaciones.filter(n => n.uidCurso == alumno.curso.uid)" :key=index>
                  <tr>
                    <td> {{itemObservaciones.fecha}} </td>
                    <!-- <td colspan="3"> {{itemObservaciones.detalle}} </td> -->
                    <td colspan="3" :id="'Obs'+alumno.dni+index"> {{verSaltoLinea('Obs'+alumno.dni+index,itemObservaciones.detalle, false )}} </td>
                  </tr>
                </tbody>
              </table>
              <table class="table" v-else>
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Date (Fecha)</th>
                    <th scope="col" colspan="3">Details (Detalles)</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="tab-pane fade" id="pills-otros" role="tabpanel" aria-labelledby="pills-otros-tab">
              <h4 class="text-uppercase text-left text-secondary mb-0 mt-3"> Reglamento del Alumno </h4  >

              <div class="text-left mt-2">
                <span style="font-size: 12px;"> La vacante de un curso se garantiza mediante el pago de la matrícula anual. Las cuotas mensuales se abonan de marzo a diciembre. Son pagos consecutivos, no se permite abonar una cuota mensual si existe una impaga previa, aunque el alumno no haya concurrido a clases. Los recargos se aplican luego del día 14 de cada  mes, con excepción de marzo que vence el día 31. Los importes abonados no se reintegran. Consultar modalidad de baja. <br> <br>
                Consideramos que la asistencia a clases es el componente fundamental del éxito del curso, por lo que apelamos a la responsabilidad individual para minimizar las inasistencias. No se pierde la condición de alumno regular por inasistencias reiteradas. Los alumnos se pueden cambiar de horario dentro del mismo nivel en cualquier momento del año, (siempre que haya vacantes disponibles).También es posible cambiar de nivel o pasar de un curso regular a uno intensivo o viceversa, previa consulta con el docente y la directora. Todo cambio de curso debe realizarse personalmente en la secretaría. <br><br>
                Es obligatorio aprobar el examen final para pasar de nivel. Los alumnos que no pueden rendir en la fecha asignada uno o los dos exámenes por algún motivo de fuerza mayor debidamente justificado ( viaje,finales del colegio o universidad, enfermedad ), podrán solicitar cambio de fecha. Los alumnos que no aprobaron el examen final en diciembre pueden rendir un examen recuperatorio en marzo. La inscripción y el pago del derecho de examen se abonan en febrero. Aquel alumno que desaprobó uno de los exámenes , tanto el escrito como el oral, y hubiera obtenido una calificación de 5 o más en el otro,puede rendir solo el examen desaprobado. <br><br>
                
                </span>
              </div>  
              
            </div>
            <div class="tab-pane fade" id="pills-book" role="tabpanel" aria-labelledby="pills-book-tab">
              <div class="text-left mt-2">
                <ul v-for="(itemLibro, index) in curso.libros" :key=index>
                  <li> {{itemLibro.nombre}} </li>
                </ul>
              </div>
                      
            </div>
          </div>
        </div>
        <br>
      </div>         <!-- COPIA -->
      <div v-if="dos">
        <div class=" row justify-content-center">
          <div class="col-8 bg-secondary pt-3 pb-3" style="border-radius: 15px;">
            <!-- <div> Alumno :   {{alumno.nombre}} </div> -->
          <div> <h5>Curso:</h5>  <h5>{{alumno.curso2.nombre}}</h5> </div>
          <div> <h6>Profesora: {{alumno.curso2.docente.nombre}}</h6>  </div>
            <button @click="mostrar2=!mostrar2"  class="btn btn-primary col-7 mb-2" type="button" data-toggle="collapse" :data-target="'#collapseExample'+2" aria-expanded="false" aria-controls="collapseExample">
             <div v-if="!mostrar2"> Ver
            </div>
            <div v-else> Ocultar
            </div>
            </button>

          </div>
        </div>
        
       
        <div class="collapse" :id="'collapseExample'+2">
          <br>
          
          <ul class="nav nav-pills mb-3 justify-content-center" id="bills-tab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="bills-home-tab" data-toggle="pill" href="#bills-home" role="tab" aria-controls="bills-home" aria-selected="true">Novedades</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="bills-profile-tab" data-toggle="pill" href="#bills-profile" role="tab" aria-controls="bills-profile" aria-selected="false">Notas</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="bills-contact-tab" data-toggle="pill" href="#bills-contact" role="tab" aria-controls="bills-contact" aria-selected="false">Observaciones</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="bills-book-tab" data-toggle="pill" href="#bills-book" role="tab" aria-controls="bills-book" aria-selected="false">Libros</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="bills-otros-tab" data-toggle="pill" href="#bills-otros" role="tab" aria-controls="bills-otros" aria-selected="false">Reglamento</a>
            </li>
          </ul>
          <div class="tab-content mt-5 mb-5" id="bills-tabContent">
            <div class="tab-pane fade show active" id="bills-home" role="tabpanel" aria-labelledby="bills-home-tab"> 
              <table class="table">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Date (Fecha)</th>
                    <th scope="col" colspan="3">Details (Detalles)</th>
                  </tr>
                </thead>
                <tbody v-for="(itemNovedad, index) in curso2.novedades" :key=index>
                  <tr>
                    <td> {{itemNovedad.fecha}} </td>
                    <!-- <td colspan="3"> {{itemNovedad.novedad}} </td> -->
                    <td colspan="3" :id="'Nov'+curso2.uid+index"> {{verSaltoLinea('Nov'+curso2.uid+index,itemNovedad.novedad, false )}} </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tab-pane fade" id="bills-profile" role="tabpanel" aria-labelledby="bills-profile-tab">
              <table class="table" v-if="alumno.notas">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Date (Fecha)</th>
                    <th scope="col">Oral (Oral)</th>
                    <th scope="col">Written (Escrito)</th>
                    <!-- <th scope="col">Commentary (Comentario)</th> -->
                  </tr>
                </thead>
                <tbody v-for="(itemNota, index) in alumno.notas.filter(n => n.uidCurso == alumno.curso2.uid)" :key=index >
                  <tr>
                    <td> {{itemNota.fecha}} </td>
                    <td> {{itemNota.oral}} </td>
                    <td> {{itemNota.escrito}} </td>
                    <!-- <td> {{itemNota.comentario}} </td> -->
                  </tr>
                  <tr v-if="itemNota.comentario != ''">
                    <!-- <td colspan="3" class="text-left" style="border-top-width: 0px; border-bottom: 0.125rem solid #dee2e6;"> <b>Comentario:</b>  {{itemNota.comentario}} </td> -->
                    <td colspan="3" :id="'Notas2'+alumno.dni+index" class="text-left" style="border-top-width: 0px; border-bottom: 0.125rem solid #dee2e6;"  > {{verSaltoLinea('Notas2'+alumno.dni+index, itemNota.comentario, true )}} </td>
                  </tr>
                </tbody>
              </table>
              <table class="table" v-else>
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Date (Fecha)</th>
                    <th scope="col">Oral (Oral)</th>
                    <th scope="col">Written (Escrito)</th>
                    <!-- <th scope="col">Commentary (Comentario)</th> -->
                  </tr>
                </thead>
              </table>
            </div>
            <div class="tab-pane fade" id="bills-contact" role="tabpanel" aria-labelledby="bills-contact-tab">
              <table class="table" v-if="alumno.observaciones">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Date (Fecha)</th>
                    <th scope="col" colspan="3">Details (Detalles)</th>
                  </tr>
                </thead>
                <tbody v-for="(itemObservaciones, index) in alumno.observaciones.filter(n => n.uidCurso == alumno.curso2.uid)" :key=index>
                  <tr>
                    <td> {{itemObservaciones.fecha}} </td>
                    <!-- <td colspan="3"> {{itemObservaciones.detalle}} </td> -->
                    <td colspan="3" :id="'Obs'+alumno.dni+index"> {{verSaltoLinea('Obs'+alumno.dni+index,itemObservaciones.detalle, false )}} </td>
                  </tr>
                </tbody>
              </table>
              <table class="table" v-else>
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Date (Fecha)</th>
                    <th scope="col" colspan="3">Details (Detalles)</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="tab-pane fade" id="bills-otros" role="tabpanel" aria-labelledby="bills-otros-tab">
              <h4 class="text-uppercase text-left text-secondary mb-0 mt-3"> Reglamento del Alumno </h4  >

              <div class="text-left mt-2">
                <span style="font-size: 12px;"> La vacante de un curso se garantiza mediante el pago de la matrícula anual. Las cuotas mensuales se abonan de marzo a diciembre. Son pagos consecutivos, no se permite abonar una cuota mensual si existe una impaga previa, aunque el alumno no haya concurrido a clases. Los recargos se aplican luego del día 14 de cada  mes, con excepción de marzo que vence el día 31. Los importes abonados no se reintegran. Consultar modalidad de baja. <br> <br>
                Consideramos que la asistencia a clases es el componente fundamental del éxito del curso, por lo que apelamos a la responsabilidad individual para minimizar las inasistencias. No se pierde la condición de alumno regular por inasistencias reiteradas. Los alumnos se pueden cambiar de horario dentro del mismo nivel en cualquier momento del año, (siempre que haya vacantes disponibles).También es posible cambiar de nivel o pasar de un curso regular a uno intensivo o viceversa, previa consulta con el docente y la directora. Todo cambio de curso debe realizarse personalmente en la secretaría. <br><br>
                Es obligatorio aprobar el examen final para pasar de nivel. Los alumnos que no pueden rendir en la fecha asignada uno o los dos exámenes por algún motivo de fuerza mayor debidamente justificado ( viaje,finales del colegio o universidad, enfermedad ), podrán solicitar cambio de fecha. Los alumnos que no aprobaron el examen final en diciembre pueden rendir un examen recuperatorio en marzo. La inscripción y el pago del derecho de examen se abonan en febrero. Aquel alumno que desaprobó uno de los exámenes , tanto el escrito como el oral, y hubiera obtenido una calificación de 5 o más en el otro,puede rendir solo el examen desaprobado. <br><br>
                
                </span>
              </div>  
              
            </div>
            <div class="tab-pane fade" id="bills-book" role="tabpanel" aria-labelledby="bills-book-tab">
              <div class="text-left mt-2">
                <ul v-for="(itemLibro, index) in curso2.libros" :key=index>
                  <li> {{itemLibro.nombre}} </li>
                </ul>
              </div>
                      
            </div>
          </div>
        </div>
      </div>

    </div>

    </div>
  </section>
  <button type="button" class="btn btn-primary mb-3 d-none" data-toggle="modal" data-target="#ModalAnio" id="ModalAnio1">
    ------
  </button>

    <!-- Modal -->
  <div class="modal fade" id="ModalAnio" tabindex="-1" role="dialog" aria-labelledby="ModalAnioTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="ModalAnioTitle">
            <div>Ingreso Alumno</div>
            </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            El DNI {{dni}} no corresponde a un Alumno del Instituto ó no esta asignado a ningun curso. <br>
            Si el problema continua comunicarme con Secretaria. <br>
            <button type="button" class="btn btn-secondary mt-4" data-dismiss="modal" id="closeAnio">Close</button>
        </div>
        <!-- <div class="modal-footer">
        </div> -->
      </div>
    </div>
  </div>

</div> 

</template>

<script>

import { mapState, mapActions , mapGetters} from "vuex";

export default {
  name: 'Alumnos',
  data(){
    return {
      mostrar: false,
      dni:'',
      spinner: false,
      uno: false,
      dos: false,
      mostrar1:false,
      mostrar2:false
    }
  },
  methods: {
    ...mapActions(['buscarAlumno', 'buscarCurso' , 'buscarCurso2','getNovedades']),
    test(){
      alert('Buscar Persona !!!')
    },
    closeMenu(){
      var navbar = $(".navbar-collapse");
      navbar.removeClass('show');
    },
    buscar(){

      this.buscarAlumno(this.dni).then(()=>{
        console.log(this.alumno);
        if(this.alumno){

          this.getNovedades()
          // this.buscarCurso(this.alumno.curso.uid)

          if(this.alumno.curso != undefined){
            if(this.alumno.curso.uid != undefined){
              this.buscarCurso(this.alumno.curso.uid)
              this.uno = true
            }
          }

          if(this.alumno.curso2 != undefined){
            if(this.alumno.curso2.uid != undefined){
              this.buscarCurso2(this.alumno.curso2.uid)
              this.dos = true
            }
          }

          this.mostrar= !this.mostrar
          this.spinner= false
        }else{
          $('#ModalAnio1').click()
          this.spinner= false
        }
      })
    },
    verSaltoLinea(asd, tex, comentario){
      // console.log(asd);
      var c = "<b>Comentario: </b>";

      if(comentario){
        tex = c + ' ' + tex
      }
      setTimeout(() => {
        $('#'+asd).html(tex);
        
      }, 10);
    },
  },
  computed: {
    ...mapState(['alumno', 'curso', 'curso2', 'novedades'])
  },
  created() {
    console.log('created');
  },
  beforeCreate() {
    console.log('beforeCreate');
  },
  mounted() {
    console.log('mounted');
  },
}
</script>

